import {
  MDBScrollspy,
  MDBScrollspyLink
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBCol,
  MDBDatatable,
  MDBRow,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getDeviceOnlineStatusInfo, getPagingDetails, getPagingGroupConfiuredDevices, updatePagingGroup, } from "../apiclients/streamsapi_bridge";
import SaveChanges from "../components/topviews/saveCancel";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";

function SelectedPagingGroups(props) {
  const {
    register,
    reset,
    watch,
    formState: { dirtyFields, isDirty, errors },
    handleSubmit,
    setError,
  } = useForm();
  const section1 = useRef(null);
  const section2 = useRef(null);

  const containerRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { state: stateData } = useLocation();
  const [groupno, setGroupNo] = useState(stateData.groupno);
  const [groupname, setGroupname] = useState(stateData.groupname);
  const [pagingId, setpagingId] = useState(stateData.pagingId);
  const [accountPagingGroups, setaccountPagingGroups] = useState(stateData.pagingGroups);
  const [selectVal, setSelectVal] = useState("africa");
  const [verticalActive, setVerticalActive] = useState("tab1");
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  
  const warningToggle = () => setShowWarning(!showWarning);

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };

  const [basicActive1, setBasicActive1] = useState("tab5");
  const [basicActive2, setBasicActive2] = useState("tab7");
  const [basicActive, setBasicActive] = useState("tab1");

  const handleBasicClick1 = (value) => {
    if (value === basicActive1) {
      return;
    }

    setBasicActive1(value);
  };
  const handleBasicClick2 = (value) => {
    if (value === basicActive2) {
      return;
    }

    setBasicActive2(value);
  };
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#")
      if (targetValues.length > 1) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1] },
          }
        );

      } else {
        navigate(targetValues[0])
      }

    }
    setShowWarning(false);
  };
  const [basicModal, setBasicModal] = useState(false);

  const [Adduser, setAdduser] = useState(false);
  const toggleShow20 = () => setAdduser(!Adduser);
  const [configuredDevicesList, setConfiguredDevices] = useState([]);

  const configuredDevices = {
    columns: [
      { label: "Phone Name", field: "PhoneName", sort: true },
      { label: "User", field: "User" },
      { label: "Extension", field: "Extension" },
      { label: "Model", field: "Model" },
      { label: "MAC Address", field: "MACAddress" },
      { label: "Online", field: "Online", sort: false },
    ],
    rows: configuredDevicesList,
  };

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [deviceuuids, setDevicesList] = useState([]);

  const redircttoPSLanding = () => {
    if (isEdited) {
      setTargetView("/pslanding#tab3");
      setShowWarning(true);
      return;
    }
    navigate("/pslanding", {
      state: { tab: "tab3" },
    });
  };
  const [successMessage, setSuccessMessage] = useState("");
  let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

  useEffect(() => {
    // if (stateData) {
      
    //   console.log(stateData)
    //   setGroupNo(stateData.groupno);
    //   setGroupname(stateData.groupname);
    //   reset({ "groupno": stateData.groupno, "groupname": stateData.groupname });
    //   
    // }
     fetchPagingDetails()
  }, []);

  const fetchPagingDetails=async()=>{
    const response = await getPagingDetails(siteid,stateData.pagingId)
    const responseData=await response.json();

    console.log("getPagingDetails Response ::::: "+JSON.stringify(responseData))
    if(!response.ok){
      console.log("getPaging Details Failed");
    }else{
      setGroupNo(responseData?.pagingDetails?.groupno);
      setGroupname(responseData?.pagingDetails?.groupname);
      reset({ "groupno": responseData?.pagingDetails?.groupno, "groupname": responseData?.pagingDetails?.groupname });
      setaccountPagingGroups(stateData.pagingGroups);
    }
  }
  
  const fetchPagingGroupsConfiuredDevices = async () => {
    let serverResponse = await getPagingGroupConfiuredDevices(siteid, groupno);
    if (!serverResponse.ok) {
      console.log("Server response was not ok");
      // throw new Error("Network response was not ok");
    }
    let response = await serverResponse.json();
    console.log("getUserListInAddDevicepage  " + response);
    var devicesList = response.responseData;
    console.log("devicesList :::::: " + JSON.stringify(devicesList));
    var devicesList = response.responseData;
    console.log("devicesList :::::: " + JSON.stringify(devicesList));
    var devises = [];
    if (devicesList) {
      devicesList.forEach((obj) => {
        let recordJo = {};
        recordJo.PhoneName = obj.phoneName;
        recordJo.User = obj.user;
        recordJo.Extension = obj.extention;
        recordJo.Model = obj.deviceModel;
        recordJo.MACAddress = obj.macAddress;
        recordJo.Online = <span className="red-dot"></span>;
        devises.push(recordJo);
      });
      setConfiguredDevices(devises);

      const devicess = devicesList.map((obj) => obj.deviceUUID);
      setDevicesList(devicess);

      // Get PaginGroups online status  update
      let macAddresses = devicesList.map((obj) => obj.macAddress);
      console.log("macAddresses :: ", macAddresses);
      var paramsJo = {
        macAddresList: macAddresses,
      };
      console.log("praramJO ::::" + JSON.stringify(paramsJo));

      let api_response = await getDeviceOnlineStatusInfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        paramsJo
      );
      console.log("api_response ::: " + api_response);
      if (!serverResponse.ok) {
        // console.log("Server response was not ok");
        // throw new Error("Network response was not ok");
      }
      let response = await api_response.json();
      console.log("api_response  " + response);
      var livedataObjectsInfo = response?.deviceStatus;
      console.log(
        "devicesStatus :::::: " + JSON.stringify(livedataObjectsInfo)
      );
      console.log(JSON.stringify(devicess));
      let configured_devices_withstatus = [];
      for (const data of devises) {
        let result = livedataObjectsInfo?.find(
          (liveobj) => data?.MACAddress == liveobj?.macaddress
        );
        data.Online = result?.online_status ? (
          <span className="green-dot"></span>
        ) : (
          <span className="red-dot"></span>
        );
        configured_devices_withstatus.push(data);
      }
      setConfiguredDevices(configured_devices_withstatus);
    }
  };

  useEffect(() => {
    setEdited(isDirty);
  }, [isDirty]);

  // const validateExistGroupId = (e) => {
  //   try {
  //     let groupId = e;
  //     console.log("changed Group  " + JSON.stringify(e));
  //     console.log("accountPagingGroups  " + JSON.stringify(accountPagingGroups));
  //     const groupExists = accountPagingGroups.some((group) => group.group_no.toString() == groupId);
  //     if (groupExists) {
  //       setError("groupno", { type: "manual", message: "Group ID already exists" });
  //     } else {
  //       setError("groupno", { type: "manual", message: "" });
  //       editPagingGroupname(formdata);
  //     }
  //   } catch (e) {
  //     console.error("[validateExistGroupId Error  " + e);

  //   }
  // }

  const onsaveChanges = async (formdata) => {

    if (isDirty) {
      try {
        console.log("formdata   " + JSON.stringify(formdata));
        console.log("accountPagingGroups  " + JSON.stringify(accountPagingGroups));
        if(formdata.groupno > 25 || formdata.groupno <=0){
          setError("groupno", { type: "manual", message: "Group ID must be between 1 and 25" });
          return;
        }
        const groupExists = accountPagingGroups.some((group) => (group.group_no.toString() == formdata.groupno));
        const nameExists = accountPagingGroups.some((group) => (group.group_name == formdata.groupname));
        console.log("OrginalGroupno :::::: " + groupno);
        if(nameExists && formdata?.groupname !== groupname){
          setError("groupname",{type:"manual",message:"Paging Group Name already exists"})
          return;
        }
        if(formdata.groupname === ""){
          setError("groupname",{type:"manual",message:"Group Name should not be empty"})
          return;
        }
        if (groupExists && formdata?.groupno !== groupno) {
          setError("groupno", { type: "manual", message: "Group ID already exists" });
          return;
        } else {
          setError("groupno", { type: "manual", message: "" });
          editPagingGroupname(formdata);
        }
      } catch (e) {
        console.error("[validateExistGroupId Error  " + e);
      }
    }
  }
  const editPagingGroupname = async (formdata) => {
    try {
      formdata = {
        ...formdata,
        groupno: parseInt(formdata.groupno),
        orginalGroup: parseInt(groupno)
      };
      console.log("Making server request [editPagingGroupname]" + JSON.stringify(formdata));
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      console.log("Making server request [editPagingGroupname] siteid " + siteid);
      let serverResponse = await updatePagingGroup(siteid, formdata);
      if (!serverResponse.ok) {
        console.log("Network Error ");
      } else {
        console.log("edit Paging GroupName Resoponce is succesfull");
        console.log(serverResponse.json());
        setSuccessMessage(`Paging Group Name successfully updated.`);
        setGroupname(formdata.groupname);
        reset(formdata);
        window.location.reload()
      }
    } catch (e) {
    }
  }
  const onCloseChanges = () => {
    reset();
  };

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    if (groupno) {
      fetchPagingGroupsConfiuredDevices();
    }
  }, [groupno]);

  // const fetchDeviceStatus = async () => {
  //   console.log("fetchDeviceStatus ::::");
  // };
  // useEffect(() => {
  //   fetchDeviceStatus();
  // }, [macAddresses]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll('.nav-link');
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest('.sticky-top');
      if (stickyParent && lastLink.classList.contains('active')) {
        lastLink.classList.remove('active');
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest('.sticky-top');
          if (parent) {
            firstLink.classList.add('active');
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

   const redirectionToSettings = (device) => {
        try {
           const { MACAddress } = device
        if (MACAddress) {
            window.open(`/ipphoneadd?mac_address=${MACAddress}`);
        } 
        } catch (error) {
          console.log("[redirectionToSettings ] Error :: " + error);
        }
    };
    
  return (
    <React.Fragment>
      <>
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={10}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a
                            onClick={(e) => {
                              if (isEdited) {
                                setTargetView("/huntgroup");
                                setShowWarning(true);
                                return;
                              }
                              navigate("/huntgroup");
                            }} >
                            <strong>{t("phoneSystem")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a onClick={redircttoPSLanding}>
                            <strong>
                              <strong>{t("PagingGroup")}</strong>
                            </strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong>{groupname}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="p-2 fw-600">{groupname}</h5>

                    <MDBTabs>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick1("tab5")}
                          active={basicActive1 === "tab5"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBRow>
                      <MDBCol
                        size="2"
                        md="2"
                        lg="2"
                        sm="12"
                        className="col-sm-100 pr-0 leftTabs"
                      >
                        {/* <MDBScrollspy container={containerRef} offset={500}>
                          <MDBScrollspyLink targetRef={section1}>
                            {t("general")}
                          </MDBScrollspyLink>
                          <MDBScrollspyLink targetRef={section2}>
                            {t("configuredDevices")}
                          </MDBScrollspyLink>
                        </MDBScrollspy> */}

                        <MDBScrollspy container={containerRef} offset={500}>
                          <MDBScrollspyLink targetRef={section1} >{t("general")}</MDBScrollspyLink>
                          <MDBScrollspyLink targetRef={section2} >{t("configuredDevices")}</MDBScrollspyLink>
                        </MDBScrollspy>

                      </MDBCol>
                      <MDBCol
                        size="12"
                        md="10"
                        sm="12"
                        pr-0
                        className="col-sm-100 pr-0 leftTabContent"
                      >
                        <div className="w-95">
                          <div className="vtabHeight pr-5">
                            <div id='element' ref={containerRef} className='scrollspy-example'>
                              <section
                                ref={section1}
                                id="section-1"
                              >


                                <h5 className="fw-600 mt-5">
                                  {t("general")}
                                </h5>
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                  <div>{t("PagingGroupName")}</div>
                                  <div>
                                    <input
                                      type="text"
                                      className="form-control selectname w-100"
                                      // value={groupname}
                                      // onChange={(e) =>
                                      //   setGroupname(e.target.value)
                                      // }
                                      maxLength={30}
                                      onKeyDown={(event) => {
                                        if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      {...register('groupname', { required: true })}

                                    />
                                    {errors.groupname && <p className="text-danger">{errors.groupname.message}</p>}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                  <div>{t("GroupID")}</div>
                                  <div>
                                    <input
                                      type="text"
                                      className="form-control selectname w-50"
                                      // value={groupno}
                                      // onChange={(e) =>
                                      //   setGroupNo(e.target.value)
                                      // }
                                      {...register(`groupno`)}
                                    />
                                    {errors.groupno && (
                                      <p className="text-danger">{errors.groupno.message}</p>
                                    )}
                                  </div>
                                </div>
                              </section>
                              <section
                                ref={section2}
                                id="section-2"
                              >
                                <h5 className="fw-600 mt-5">
                                  {t("configuredDevices")}{" "}
                                </h5>
                                <div>
                                  <MDBDatatable sortField="Phone Name"
                                    noFoundMessage={t("NotFoundMessage")}
                                    data={configuredDevices}
                                    pagination={false}
                                    style={
                                      { minHeight: "50vh" }
                                    }
                                    onRowClick={(data) => redirectionToSettings(data)}
                                  />
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </div>
              </section>
            </>
          }
        />
        {successMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )}
        {/* <Footer /> */}
        {isDirty && (
          <SaveChanges
            onClose={onCloseChanges}
            onSave={(e) => {
              handleSubmit(onsaveChanges)();
            }}
          />
        )}

        {showWarning && (
          <EditWarning
            warningToggle={warningToggle}
            setShowWarning={setShowWarning}
            onOk={handleOk}
          />
        )}
      </>
    </React.Fragment>

  );
}
export default SelectedPagingGroups;
